import React, { useState, useEffect } from 'react'
import { Dialog, Grid, DialogActions, DialogTitle, DialogContent, Button, Tooltip, IconButton, TextField, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../reducers/form';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import arrowType from './gantArrowType'
import { addArrowWorkToGant } from '../../api/form-gant.api'
import { fetchDispath } from '../../functions/fetch'
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import { addGantArrow } from '../../reducers/gant'
import Autocomplete from '@mui/material/Autocomplete';

function AutoNew({ options, value, onChange, placeholder }) {
  const safeValue = value && value.value !== null && value.value !== undefined ? value : null;
  return (
    <Autocomplete
      disablePortal={false}
      options={options || []}
      disableClearable
      value={safeValue}
      onChange={onChange}
      isOptionEqualToValue={(option, val) => {
        if (!option || !val) return false;
        return String(option.value) === String(val.value);
      }}
      getOptionKey={(option) => option.value || ''}
      renderOption={(props, option) => (
        <Tooltip title={option.label} placement="top-start" enterDelay={500} key={option.value}>
          <Box
            component="li"
            {...props}
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block !important'
            }}
          >
            {option.label}
          </Box>
        </Tooltip>
      )}
      renderInput={(params) => <TextField {...params} sx={{ mb: 2 }} autoFocus variant="standard" label={placeholder} />}
    />
  );
}


export default function GantAddArrow({ formName, idProject }) {
  const [open, setOpen] = useState(false)
  return (
    <React.Fragment>
      <Tooltip title="Добавить связь" aria-label="add">
        <IconButton color='primary' onClick={() => setOpen(true)} size="large"><SettingsEthernetIcon /></IconButton>
      </Tooltip>
      {open && <ArrowDialog open={open} onClose={() => setOpen(false)} formName={formName} idProject={idProject} />}
    </React.Fragment>
  );
}

function ArrowDialog({ formName, idProject, open, onClose }) {
  const [workFrom, setWorkFrom] = useState({
    value: null,
    idAPI: '',
    label: '',
    index: 0
  })
  const [workTo, setWorkTo] = useState({
    value: null,
    idAPI: '',
    label: '',
    index: 0
  })
  const [type, setArrType] = useState(arrowType.arr[0])
  const dispatch = useDispatch()
  const gantFlat = useSelector(state => state.gant.flat)
  const byId = useSelector(state => state.form[formName]?.values.byId || {})
  const [arr, setArr] = useState([])
  useEffect(() => {
    setArr(gantFlat.filter(e => !e.color).map((e, i) => {
      const obj = byId['id' + e.id]
      return {
        value: obj.id,
        idAPI: obj.idAPI,
        label: `${e.pos} ${obj.name}`,
        index: i
      }
    }))
  }, [gantFlat, byId])

  const changeWork = (text, type) => {
    if (type === 'form') {
      setWorkFrom(text)
    }
    else {
      setWorkTo(text)
    }
  }
  const handleOk = () => {
    const obj = byId[workFrom?.value]
    dispatch(fetchDispath({
      param: {
        id: idProject,
        idWork: obj.idAPI
      },
      body: {
        idTo: workTo?.idAPI,
        typeArrow: type?.value,
      },
      request: addArrowWorkToGant,
    })).then(res => {
      dispatch(actions.formObjChange([...obj.dependencies, {
        id: res.id,
        to: workTo?.value,
        toIndex: workTo.index,
        type: type.value
      }], {
        name: formName,
        field: 'byId',
        fieldObj: 'dependencies',
        id: workFrom.value
      }))
      dispatch(addGantArrow({
        fromId: obj.idAPI,
        id: res.id,
        to: workTo.idAPI,
        type: type.value
      }))
      onClose()
    }).catch(err => console.log(err))
  }
  return (
    <React.Fragment>
      <Dialog
        open={open}
        maxWidth='sm'
        keepMounted
        fullWidth
        scroll="paper"
        onClose={onClose}
        aria-labelledby="gantt-arrow-add-title"
      // PaperProps={{ style: { height: 450 } }}
      >
        <DialogTitle id="gantt-arrow-add-title">Создать связь</DialogTitle>
        <DialogContent >
          <AutoNew
            options={arr}
            onChange={(event, newValue) => setWorkFrom(newValue)}
            value={workFrom || null}
            placeholder='Начало'
          />
          <AutoNew
            options={arr}
            onChange={(event, newValue) => setWorkTo(newValue)}
            value={workTo || null}
            placeholder='Конец'
          />
          <AutoNew
            options={arrowType.arr}
            onChange={(event, newValue) => setArrType(newValue)}
            value={type || null}
            placeholder='Тип связи'
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'flex-end' }}>
              <Button
                variant="text"
                color="inherit"
                startIcon={<CloseIcon />}
                onClick={onClose}
                size='small'
              >Отменить
              </Button>
              <Button
                variant="contained"
                color="primary"
                startIcon={<CheckIcon />}
                onClick={handleOk}
                size='small'
                disabled={!workFrom?.value || !workTo?.value}
              >Сохранить
              </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

